import { render } from "./DSPOverviewModal.vue?vue&type=template&id=6c37adb4&scoped=true&ts=true"
import script from "./DSPOverviewModal.vue?vue&type=script&lang=ts"
export * from "./DSPOverviewModal.vue?vue&type=script&lang=ts"

import "./DSPOverviewModal.vue?vue&type=style&index=0&id=6c37adb4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c37adb4"]])

export default __exports__